import React from 'react';
import { Router } from 'react-router-dom';
import './App.css';
import { Provider } from 'react-redux';
import Routes from './routes/routesAdm';
import 'react-datepicker/dist/react-datepicker.css'; // 👈 ADICIONE ESTA LINHA

import history from './services/history';
import { AuthProvider } from './Context/AuthContext';

import Store from './store/configureStore';
import Footer from './components/Footer/Footer';
import { BottomNav } from './components/BottomNav';
import { ErrorProvider } from './Context/ErrorContext';

function App() {
  return (
    <div>
      <ErrorProvider>
        <AuthProvider>
          <Provider store={Store}>
            <Router history={history}>
              <main className="d-flex flex-column">
                <Routes />
                <Footer />
                <BottomNav />
              </main>
            </Router>
          </Provider>
        </AuthProvider>
      </ErrorProvider>
    </div>
  );
}

export default App;
